import { createRouter, createWebHistory } from "vue-router";

import Layout from "../views/layout/Layout.vue";

export const constantRouterMap = [
  {
    path: "/404",
    component: () => import("@/views/404.vue"),
    hidden: true
  },
  {
    path: "/",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/globalRaceRankBoard",
        component: () => import("@/views/globalRaceRankBoard/index.vue")
      },
      {
        path: "/dynamicRankBoard",
        component: () => import("@/views/dynamicRankBoard/global.vue")
      },
      {
        path: "/drb",
        component: () => import("@/views/dynamicRankBoard/global.vue")
      },
      {
        path: "/rankBoard",
        component: () => import("@/views/commonRankBoard/index.vue")
      },
      {
        path: "/r/:channel",
        component: () => import("@/views/commonRankBoard/index.vue")
      },
      {
        path: "/wxRankBoard",
        component: () => import("@/views/wxRankBoard/index.vue")
      },
      // 全国赛决赛排行榜
      {
        path: "/d/:channel",
        component: () => import("@/views/dynamicRankBoard/index.vue")
      },
      {
        path: "/:channel",
        component: () => import("@/views/commonRankBoard/index.vue")
      }
    ]
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
    hidden: true
  }
];

const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 History 模式
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});

export default router;
